import React from 'react';
import { motion } from 'framer-motion';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Maria",
      role: "Beginner English Learner",
      image: "https://kcgdwjmwmfciiiryhagj.supabase.co/storage/v1/object/public/myimage//image_68649cc219ba1.jpg",
      quote: "Learning English through music has been a game-changer! I can finally understand the lyrics to my favorite songs."
    },
    {
      name: "James",
      role: "Intermediate English Speaker",
      image: "https://kcgdwjmwmfciiiryhagj.supabase.co/storage/v1/object/public/myimage//image_68649d1720200.jpg",
      quote: "The interactive exercises based on real songs helped me improve my vocabulary and pronunciation significantly."
    },
    {
      name: "Sofie",
      role: "Advanced English Student",
      image: "https://kcgdwjmwmfciiiryhagj.supabase.co/storage/v1/object/public/myimage//image_68649d496b871.jpg",
      quote: "I love how this platform combines my passion for music with language learning. It makes practice fun and engaging!"
    }
  ];

  return (
    <section className="py-16 px-6 bg-gradient-to-b from-indigo-950 to-black">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">What Our Students Say</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Join thousands of satisfied learners who are mastering English through music
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-6 border border-gray-800"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="flex items-center mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div className="ml-4">
                  <h4 className="font-bold">{testimonial.name}</h4>
                  <p className="text-sm text-gray-400">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-gray-300 italic">"{testimonial.quote}"</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;